import { DepoimentoService } from 'src/app/services/class/depoimento.service';
import { Depoimento } from 'src/app/models/depoimento.model';
// Default
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoadingService } from './../../services/loading.service';
import { HelperService } from './../../services/helper.service';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { HttpProgressEvent } from '@angular/common/http';

@Component({
  selector: 'app-depoimentos-editar',
  templateUrl: './depoimentos-editar.component.html',
  styleUrls: ['./depoimentos-editar.component.scss']
})
export class DepoimentosEditarComponent implements OnInit {

  data: Depoimento = new Depoimento();

  buscarSubscription: Subscription;

  file: File;
  progress: number;

  constructor(
    public depoimentoService: DepoimentoService,
    public helper: HelperService,
    public loadingService: LoadingService,
    public router: Router,
    public route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.params.subscribe(param => this.buscar(param.id));
  }

  ngOnDestroy() {
    this.buscarSubscription.unsubscribe();
  }

  buscar(id: number) {
    this.buscarSubscription = this.depoimentoService.getById(id)
      .subscribe((res: Depoimento) => this.data = res);
  }

  submit(f: NgForm) {

    if (f.invalid) {
      this.helper.formMarkAllTouched(f);
      this.helper.openSnackBar('Preencha os campos requiridos, por favor!');
      return;
    }

    this.loadingService.present('Alterando...');

    this.depoimentoService.patch(this.data)
      .subscribe((res: any) => {
        // as imagens ja foram enviadas ao selecionar o arquivo; a URL esta no proprio data
        this.helper.openSnackBar('Item alterado com sucesso.');
        this.router.navigate(['/depoimentos']);
        this.loadingService.dismiss();
      }, e => {
        this.helper.openSnackBar(e.error);
        this.loadingService.dismiss()
      });

  }

  @ViewChild('fileInput', { static: true }) fileInput: ElementRef;
  onFileSelected(files) {
    this.file = files.item(0);
    this.loadingService.present('0%');
    this.submitImages(this.file, `/depoimento/foto?id=-99`).then((res: any) => {
      this.data.foto = res.body;
      this.loadingService.dismiss();
    }).catch(() => {
      this.progress = 0;
      this.fileInput.nativeElement.value = '';
      this.loadingService.dismiss();
    });
  }

  submitImages(file: File, url: string) {
    if (!file) {
      return;
    }
    return new Promise((resolve, reject) => {
      this.depoimentoService.postFile(file, url, 'image')
        .subscribe((event: HttpProgressEvent | any) => {
          if (event.type === 4) {
            this.progress = 0;
            resolve(event);
          } else {
            this.progress = Math.round((event.loaded / event.total) * 100);
            if (isNaN(this.progress)) {
              this.progress = 100;
            }
            this.loadingService.title = `${this.progress}%`;
          }
        }, err => reject(err));
    });
  }

  removeFoto() {
    this.data.foto = '';
  }

}
